import { motion } from 'motion/react';
import { Zap } from 'lucide-react';
import { useAuthStore } from '@/lib/stores/authStore';

interface QuickWorkoutCardProps {
  onQuickWorkout: () => void;
  isLoading?: boolean;
  onShowAuth?: () => void;
}

export function QuickWorkoutCard({ onQuickWorkout, isLoading, onShowAuth }: QuickWorkoutCardProps) {
  const { isAuthenticated } = useAuthStore();

  const handleClick = () => {
    if (isAuthenticated) {
      onQuickWorkout();
    } else {
      onShowAuth?.();
    }
  };

  return (
    <motion.button
      onClick={handleClick}
      disabled={isLoading}
      className="w-full text-left bg-neutral-900 text-white rounded-xl p-6 hover:bg-neutral-800 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
          <Zap className="w-5 h-5" />
        </div>
      </div>

      <h3 className="text-2xl font-bold mb-2">
        Quick Workout
      </h3>
      
      <p className="text-white/70">
        Let us create the perfect workout for you right now
      </p>
    </motion.button>
  );
}

